import Loader from './loader';
import AddressLoader from './address_loader';
import Cep from './cep';
import Confetti from './confetti'
import { autoDetectAndViewImage, detectType, toggleVisibility } from './image_viewer';
import AutoComplete from './autocomplete';

export default {
  Loader,
  AddressLoader,
  Cep,
  Confetti,
  AutoComplete,
  autoDetectAndViewImage,
  detectType,
  toggleVisibility
};

export { Loader, AddressLoader, Cep, Confetti, AutoComplete, autoDetectAndViewImage, detectType, toggleVisibility };
